// src/services/debug_api.js
import { apiClient } from './api_client';


const debugApi = {
    retrieveDebugLogs: async (sessionId, debugIds = [], chatId = null) => {
        try {
            const response = await apiClient.post('/debug/retrieve_logs', {
                session_id: sessionId,
                chat_id: chatId,
                debug_ids: debugIds
            });
            return response.data;
        } catch (error) {
            console.error('Error retrieving debug logs:', error);
            return [];
        }
    }
};

export default debugApi;